﻿import { initRegisterForm } from "./register";
import { getCitiesSearch, getWorkstations } from "../../api/entities";
import { getCookie } from "../../storage";
import { updatePostalCodeMessage } from "./step3";
import { closeModal, EuiModalSize, showModal } from "../../components/modal";

const MAX_USER_PREFERENCES = 5;
const MAX_RECOMMENDED_PREFERENCES = 8;
const RECOMMENDED_PREFERENCES = [
  114, 213, 1, 46, 472, 44, 42, 2, 497, 200, 126, 15, 527, 192, 108, 470, 471,
  202, 464, 214, 134,
];

let jobPreferences = [];
let USER_SELECTED_PREFERENCES = [];

const selectors = {
  anotherMomentBtn: () => $("#anotherMomentNextBtn"),
  registerNextBtn: () => $("#registerNextBtn"),
  alertsSwitchFooter: () => $(".aw-register-step-4__footer-switch"),
  alertsSwitch: () => $(".aw-register-step-4__footer-switch label"),
  alertsSwitchInput: () => $("#NeedSetAlerts"),
  preferencesList: () => $("#preferencesList"),
  preferencesForm: () => $("#registerStep4Form"),
  preferenceFilter: () =>
    $("#preferencesList .eui-autocomplete #autocompleteInput"),
  autocompleteWrapper: () => $(".preferencesList"),
  autocomplete: () => $("#preferencesList .eui-autocomplete"),
  autocompleteList: () =>
    $("#preferencesList .eui-autocomplete .eui-autocomplete__list"),
  autocompleteRecommendedList: () =>
    $(
      "#preferencesList .eui-autocomplete .eui-autocomplete__list--recommended"
    ),
  autocompleteRecommendedListItems: () =>
    $(
      "#preferencesList .eui-autocomplete .eui-autocomplete__list--recommended-items"
    ),
  autocompleteNoResults: () =>
    $("#preferencesList .eui-autocomplete .eui-autocomplete__list--no-results"),
  userSelectionList: () =>
    $(".aw-preferences ul.aw-preferences-user-selection"),
  preferencesWrapper: () => $(".aw-preferences"),
  cleanFilterIcon: () =>
    $(".pref-clean-filter-btn", selectors.preferenceFilter().parent()),
  refillPreferencesBtn: () => $("#refillPreferencesBtn"),
  refillPreferencesContinueBtn: () => $('#refillPreferencesContinueBtn')
};

$(() => {
  const preferencesForm = selectors.preferencesForm();

  initRegisterForm(preferencesForm);

  selectors
    .preferencesList()
    .on("click", ".eui-checkbox", handlePreferenceItemClick);
  $(".aw-preferences-user-selection").on(
    "click",
    ".eui-chip .eui-icon",
    removeSelectedPreference
  );
  selectors.preferenceFilter().on("input", handlePreferenceFilter);
  selectors.preferenceFilter().on("keypress", handleFilterKeyPress);
  selectors.anotherMomentBtn().on("click", handleAnotherMomentClick);
  selectors.refillPreferencesBtn().on("click", () => closeModal());
  selectors.refillPreferencesContinueBtn().on("click", handleRefillPreferenceContinueBtn);

  $("button[type='submit']", preferencesForm).on("click", (ev) => {
    ev.preventDefault();
    preferencesForm.trigger("submit");
  });

  updateAlertsState();
  loadPreferences();
});

function loadPreferences() {
  getWorkstations(true)
    .done((preferences) => {
      jobPreferences = preferences;
      preferences.forEach((preference) => {
        selectors
          .autocompleteList()
          .append(createListOption(preference.description, preference.id));
      });

      generateRecommendedPreferences();
      focusOnSearch();
    })
    .fail(() => {
      console.error("Error fetching workstations");
    });
}

function handleAnotherMomentClick(ev) {
  showModal($("#checkEmptyPreferences"), {
    overlayClose: false,
    size: EuiModalSize.S,
  });
}

function handleFilterKeyPress(ev) {
  if (ev.key === "Enter") {
    const filterOpt = $(
      "#preferencesList .eui-autocomplete .eui-autocomplete__list .eui-autocomplete-item:visible"
    ).toArray();

    if (filterOpt.length > 0) $(filterOpt[0]).trigger("click");
  }
}

function handlePreferenceItemClick(event) {
  event.stopPropagation();
  const $input = $(this).find('input[type="checkbox"]');

  if (event.target.type !== "checkbox") {
    $input.prop("checked", !$input.prop("checked"));
    $input.trigger("change");
  }

  const value = $(this).data("eui-value");
  const userHasPreference = USER_SELECTED_PREFERENCES.includes(value);

  if (!userHasPreference) {
    const text = $(this).text().trim();
    addPreference(value, text);
  } else {
    removePreference(value);
  }
}

function handlePreferenceFilter(ev) {
  ev.stopPropagation();

  const autocompleteList = selectors.autocompleteList();
  const userSelectionList = getUserSelectionList();
  const autocompleteText = normalizeText($(ev.target).val());

  autocompleteList.empty();
  selectors.autocompleteRecommendedListItems().empty();

  if (autocompleteText.length === 0) {
    handleEmptyFilter();
    return;
  }

  selectors.autocompleteRecommendedList().addClass("eui-d-none");
  autocompleteList.removeClass("eui-d-none");

  const matchedPreferences = jobPreferences.filter((preference) => {
    const normalizedDescription = normalizeText(preference.description);
    return (
      normalizedDescription.includes(autocompleteText) &&
      !userSelectionList.includes(preference.id)
    );
  });

  matchedPreferences.forEach((preference) => {
    autocompleteList.append(
      createListOption(preference.description, preference.id)
    );
  });

  updateFilterUI(autocompleteText, matchedPreferences.length);
}

function handleEmptyFilter() {
  selectors.autocompleteList().addClass("eui-d-none");
  selectors.autocompleteRecommendedList().removeClass("eui-d-none");
  selectors
    .autocompleteNoResults()
    .removeClass("eui-d-flex")
    .addClass("eui-d-none");

  generateRecommendedPreferences();

  if (selectors.autocompleteRecommendedListItems().children().length === 0) {
    selectors.autocompleteList().removeClass("eui-d-none");
    selectors.autocompleteRecommendedList().addClass("eui-d-none");
  }
}

function handleRefillPreferenceContinueBtn() {
  closeModal();
  selectors.preferencesForm().trigger("submit");
}

function updateFilterUI(filterText, resultsCount) {
  const cleanFilterIcon = selectors.cleanFilterIcon();

  if (resultsCount === 0) {
    selectors.autocompleteList().addClass("eui-d-none");
    selectors
      .autocompleteNoResults()
      .removeClass("eui-d-none")
      .addClass("eui-d-flex");
  } else {
    selectors.autocompleteList().removeClass("eui-d-none");
    selectors
      .autocompleteNoResults()
      .addClass("eui-d-none")
      .removeClass("eui-d-flex");
  }

  if (filterText) {
    cleanFilterIcon.removeClass("eui-d-none");
    cleanFilterIcon.on("click", () => {
      clearPreferenceAutocomplete();
    });
  } else {
    cleanFilterIcon.addClass("eui-d-none");
    selectors.preferenceFilter().off("click");
  }
}

function createListOption(text, value) {
  return $(`
    <div class="eui-checkbox eui-cursor-pointer eui-w-100 eui-autocomplete-item" data-eui-value="${value}">
      <input id="preference${value}" type="checkbox" name="preference${value}" class="eui-checkbox__input not-track" value="${value}" />
      <span class="eui-checkbox__checkmark"></span>
      <span class="eui-content eui-content--f1 eui-content--m eui-color-grey-800">
        ${text}
      </span>
    </div>
  `);
}

function createChip(jobPreference, text) {
  return $(`
    <span class="eui-chip eui-chip--s eui-chip--blue eui-chip--hover eui-chip--with-icon eui-d-flex eui-d-flex--inline aw-preference" data-id="${jobPreference.id}" data-eui-value="${jobPreference.id}" ${jobPreference.idGroup ? `data-groupid="${jobPreference.idGroup}"` : ``}">
      <span class="eui-chip__content eui-mr-5">${text}</span>                            
      <div class="eui-chip__action">
        <span class="eui-d-inline-flex eui-icon eui-icon--small">
          <svg role="img" fill="var(--eui-color-primary-800)" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="eui-d-block">
            <path d="M3.52827 3.52861C3.78862 3.26826 4.21073 3.26826 4.47108 3.52861L7.99967 7.0572L11.5283 3.52861C11.7886 3.26826 12.2107 3.26826 12.4711 3.52861C12.7314 3.78896 12.7314 4.21107 12.4711 4.47141L8.94248 8.00001L12.4711 11.5286C12.7314 11.789 12.7314 12.2111 12.4711 12.4714C12.2107 12.7318 11.7886 12.7318 11.5283 12.4714L7.99967 8.94282L4.47108 12.4714C4.21073 12.7318 3.78862 12.7318 3.52827 12.4714C3.26792 12.2111 3.26792 11.789 3.52827 11.5286L7.05687 8.00001L3.52827 4.47141C3.26792 4.21107 3.26792 3.78896 3.52827 3.52861Z"></path>
          </svg>
        </span>
      </div>
      <span class="eui-chip__background"></span>
    </span>
  `);
}

function addPreference(id, text) {
  const prefWrapper = selectors.preferencesWrapper();
  const userSelectionList = selectors.userSelectionList();
  const jobPreference = jobPreferences.find(
    (preference) => preference.id === +id
  );

  if (!jobPreference) return;

  userSelectionList.prepend(createChip(jobPreference, text));

  if (hasSelectedPreferences()) {
    $(".aw-preferences .eui-message--error").addClass("eui-d-none");
    prefWrapper.removeClass("aw-preferences--no-selected");
  } else {
    prefWrapper.addClass("aw-preferences--no-selected");
  }

  selectors.anotherMomentBtn().addClass("eui-d-none");
  selectors.registerNextBtn().removeClass("eui-d-none");
  selectors.alertsSwitch().removeClass("eui-switch--disabled");
  selectors.alertsSwitchInput().removeAttr("disabled");

  USER_SELECTED_PREFERENCES.push(id);
  if (USER_SELECTED_PREFERENCES.length === MAX_USER_PREFERENCES) {
    selectors.autocompleteWrapper().toggleClass("preferencesList--disabled");
    selectors.autocomplete().toggleClass("eui-autocomplete--disabled");
    clearPreferenceAutocomplete();
  }
  userSelectionList.addClass('aw-preferences-user-selection--with-values');
}

function removeSelectedPreference() {
  event.stopPropagation();
  const euiChip = $(this).parent().parent();
  const id = $(euiChip[0]).data("id");

  const preferenceListItem = $(
    `.eui-autocomplete__list--recommended:not(.eui-d-none) .eui-checkbox[data-eui-value="${id}"], 
    .eui-autocomplete__list:not(.eui-d-none) .eui-checkbox[data-eui-value="${id}"]`
  );

  if (!preferenceListItem[0]) {
    removePreference(id);
  } else {
    preferenceListItem.trigger("click");
  }
}

function removePreference(value) {
  const prefWrapper = selectors.preferencesWrapper();
  const userSelectionList = selectors.userSelectionList();
  const elToRemove = userSelectionList.find(`.eui-chip[data-id="${value}"]`);

  elToRemove.remove();
  updateAutoCompleteItemsState();

  if (hasSelectedPreferences()) {
    prefWrapper.removeClass("aw-preferences--no-selected");
  } else {
    selectors.anotherMomentBtn().removeClass("eui-d-none");
    selectors.registerNextBtn().addClass("eui-d-none");
    selectors.alertsSwitch().addClass("eui-switch--disabled");
    selectors.alertsSwitchInput().attr("disabled", true);
    prefWrapper.addClass("aw-preferences--no-selected");
  }

  USER_SELECTED_PREFERENCES = USER_SELECTED_PREFERENCES.filter(
    (userValue) => userValue !== value
  );

  selectors.autocompleteWrapper().removeClass("preferencesList--disabled");
  selectors.autocomplete().removeClass("eui-autocomplete--disabled");

  if (USER_SELECTED_PREFERENCES.length === 0) {
    selectors.alertsSwitch().addClass("eui-switch--disabled");
    selectors.alertsSwitchInput().attr("disabled", true);
    selectors.alertsSwitchInput().prop("checked", false);
    userSelectionList.removeClass('aw-preferences-user-selection--with-values');
  }
}

function normalizeText(text) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "");
}

function hasSelectedPreferences() {
  return selectors.userSelectionList().find(".eui-chip").length > 0;
}

function clearPreferenceAutocomplete() {
  selectors.preferenceFilter().val("");
  selectors.preferenceFilter().trigger("input");
}

function updateAutoCompleteItemsState() {
  const prefWrapper = selectors.preferencesWrapper();
  const userSelectionList = $(
    "ul.aw-preferences-user-selection .aw-preference",
    prefWrapper
  )
    .map((_, domEl) => $(domEl).data("eui-value"))
    .toArray();

  const autocompleteList = selectors.autocompleteList();

  if (!userSelectionList.length) return;

  autocompleteList
    .find(`.eui-autocomplete-item--active`)
    .removeClass("eui-autocomplete-item--active");

  userSelectionList.forEach((prefId) => {
    autocompleteList
      .find(`.eui-autocomplete-item[data-eui-value=${prefId}]`)
      .addClass("eui-autocomplete-item--active");
  });
}

function getUserSelectionList() {
  return $(".aw-preferences .aw-preferences-user-selection .aw-preference")
    .toArray()
    .map((prefEl) => $(prefEl).data("eui-value"));
}

function generateRecommendedPreferences(autocompleteText = "") {
  const recommendedPreferences = [];
  const userSelectionList = getUserSelectionList();

  RECOMMENDED_PREFERENCES.forEach((preferenceId) => {
    const jobPreference = jobPreferences.find((jp) => jp.id === preferenceId);
    if (jobPreference) recommendedPreferences.push(jobPreference);
  });

  recommendedPreferences.forEach((preference) => {
    const normalizedDescription = normalizeText(preference.description);
    const shouldDisplay =
      normalizedDescription.includes(autocompleteText) &&
      !userSelectionList.includes(preference.id) &&
      selectors.autocompleteRecommendedListItems().children().length <
        MAX_RECOMMENDED_PREFERENCES;

    if (shouldDisplay) {
      selectors
        .autocompleteRecommendedListItems()
        .append(createListOption(preference.description, preference.id, true));
    }
  });
}

export function getPreferences() {
  const userSelectionList = selectors.userSelectionList();
  const jobPreferences = [];

  $(".aw-preference", userSelectionList).each((_, preference) => {
    jobPreferences.push({
      Id: $(preference).attr("data-id"),
      GroupId: $(preference).attr("data-groupid"),
    });
  });

  return jobPreferences;
}

export async function updateAlertsState(postalCode = null) {
  try {
    const savedRegisterValues = getCookie(REGISTER_COOKIE_NAME);
    if (!savedRegisterValues) return;

    const registerValues = JSON.parse(savedRegisterValues);
    const registerPostalCode =
      postalCode ?? parseInt(registerValues.values.PostalCode?.split(", "[0]));
    const idCountry = CURRENT_COUNTRY_CODE;

    const result = await getCitiesSearch(idCountry, registerPostalCode, false);

    if (result && result.length > 0) {
      selectors.alertsSwitchFooter().removeClass("eui-d-none");
      updatePostalCodeMessage(false);
    } else {
      selectors.alertsSwitchFooter().addClass("eui-d-none");
      if (registerPostalCode !== null && !isNaN(registerPostalCode)) {
        updatePostalCodeMessage(true);
      }
    }
  } catch (error) {
    console.error("Error updating alerts state:", error);
  }
}

export const focusOnSearch = () => {
  setTimeout(() => {
    selectors.preferenceFilter().focus();
  }, 500);
};
